import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components/macro';
import mainDrawing from 'assets/images/main.png';
import { topicsData, ITopic } from 'config/topics';
import { useDispatch } from 'react-redux';
import { updateTopic } from 'redux/actions/topicAction';
import { isNil } from 'lodash-es';
import { msTransition } from 'helpers/msTransition';
import { useTypedSelector } from 'redux/reducers';
import { hexToRgb } from 'helpers/hexToRgb';
import { ITopicHover } from 'components/Frame/Frame';
import { visieTopics } from 'config/visieTopics';
import { ColorNames } from 'theme/colors';

interface IProps extends ITopicHover {
  src?: string;
}

const StyledDrawing = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const StyledSVG = styled.svg`
  position: absolute;
  max-height: 100%;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
`;

const StyledPath = styled.path<{ active: boolean; filled: boolean; color: ColorNames }>`
  fill: ${({ theme, filled, active, color }) => {
    if (filled && active === false) {
      return `rgba(${hexToRgb(theme.colors[color], 'string')}, 0.5)`;
    }
    return 'transparent';
  }};
  cursor: pointer;
  transition: ${({ theme }) => msTransition(theme.transition.slow)};
`;

export const Drawing: React.FC<IProps> = React.memo(({ src, hoveredTopic, setHoveredTopic }) => {
  const dispatch = useDispatch();
  const activeTopic = useTypedSelector((state) => state.topic.selected);

  const handleNavItemClick = useCallback((topic: ITopic) => () => {
    dispatch(updateTopic(topic));
  }, [dispatch]);

  const handleTopicMouseOver = useCallback((topic: ITopic) => () => {
    setHoveredTopic(topic);
  }, [setHoveredTopic]);

  const handleTopicMouseLeave = useCallback(() => {
    setHoveredTopic(undefined);
  }, [setHoveredTopic]);

  // Done for Z-index of the paths
  const reversedMainTopics = useMemo(() => topicsData.reverse(), []);

  return (
    <StyledDrawing>
      <StyledSVG xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 3840 2160">
        <image width="3840" height="2160" xlinkHref={isNil(src) ? mainDrawing : src} overflow="visible" />
        {activeTopic.group === 'visie'
          ? visieTopics.map((x) => (
            <StyledPath
              key={x.id}
              d={x.svgPath}
              color="white"
              onClick={handleNavItemClick(x)}
              filled={activeTopic.id === x.id || hoveredTopic?.id === x.id}
              active={activeTopic.id === x.id}
              onMouseOver={handleTopicMouseOver(x)}
              onMouseLeave={handleTopicMouseLeave}
            />
          ))
          : reversedMainTopics.map((x) => x.svgPath && (
            <StyledPath
              key={x.id}
              d={x.svgPath}
              color="green"
              onClick={handleNavItemClick(x)}
              filled={activeTopic.id === x.id || hoveredTopic?.id === x.id}
              active={activeTopic.id === x.id}
              onMouseOver={handleTopicMouseOver(x)}
              onMouseLeave={handleTopicMouseLeave}
            />
          ))}
      </StyledSVG>
    </StyledDrawing>
  );
});